import { Button } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDataSourcesModal, bindBotDatasets, DataSourcesType } from '@mygpt/app';
import { useCreateStore } from '@/store/create';

interface Props {
  disabled: boolean;
  type: DataSourcesType;
}

const GoToListButton = ({ disabled, type }: Props) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const { onClose } = useDataSourcesModal();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const botId = queryParams.get('botId');
  const { datasetId } = useCreateStore();
  const gotToList = async () => {
    if (botId) {
      bindBotDatasets({
        aiId: botId,
        datasetIds: [datasetId],
        type: 'bind',
      })
        .then((res) => {
          navigate(`/bot/${botId}/chat`);
        })
        .finally(() => {})
        .catch((err) => {});
      // const { data } = await getRobot({ aiId: botId });
      // const params = {
      //   aiId: botId,
      //   name: data.name,
      //   subject_name: data.subject_name,
      //   discrible: data.discrible,
      //   ai_type: data.ai_type,
      //   robot_type: data.robot_type,
      //   prompt: data.prompt || '',
      //   embedding_model_name: embeddingModelName,
      // };

      // try {
      //   await updateRobot(params);
      //   navigate(`/bot/${botId}/chat`);
      // } catch (error) {
      //   console.error(error);
      // }
    } else {
      onClose();
      const parts = pathname.split('/');
      parts.pop();
      parts.push(type);
      navigate(parts.join('/'));
    }
  };

  return (
    <Button size="md" disabled={disabled} onClick={gotToList}>
      {t('alert_ok')}
    </Button>
  );
};

export default ({ disabled, type }: Props) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { botId, pageType } = useCreateStore();
  const [loading] = useDisclosure(false);
  const gotToChat = () => navigate(`/bot/${botId}/chat`);

  if (pageType === 'modify') {
    return <GoToListButton disabled={disabled} type={type} />;
  }

  return (
    <Button size="md" disabled={disabled} onClick={gotToChat} loading={loading}>
      {t('data_check.start_chatting')}
    </Button>
  );
};
